module.exports = __webpack_public_path__ + "img/p15076.41a5759a.jpg";